import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Icon from "../../../icons/main";
type ListTileType = {
  title: string;
  subtitle?: string;
  avatarType: string;
  alignItems: string;
  avatarSrc?: string;
  iconSrc?: string;
  altText?: string;
  // showLine?: boolean;
  avatarBackgroundColor?: string;
  // lastElement?: boolean;
};
const ListTile = ({
  title,
  subtitle,
  avatarType,
  avatarSrc,
  iconSrc,
  altText,
  alignItems,
  avatarBackgroundColor,
}: ListTileType) => {
  return (
    <ListItem
      alignItems={alignItems === "center" ? "center" : "flex-start"}
      sx={{ marginBottom: "-6px" }}
      data-testid="list-item"
    >
      <ListItemAvatar
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        {avatarType === "image" ? (
          <Avatar alt={altText} src={avatarSrc as string} />
        ) : (
          <Avatar
            sx={{
              width: "2.2rem",
              height: "2.2rem",
              borderRadius: "50%",
              backgroundColor: avatarBackgroundColor,
            }}
          >
            {Icon[iconSrc as string]({
              width: {
                xs: "1.015rem",
                md: "1.125rem",
                lg: "1.125rem",
                xl: "1.125rem",
              },
              height: {
                xs: "1.015rem",
                md: "1.125rem",
                lg: "1.125rem",
                xl: "1.125rem",
              },
              strokeColor: "black",
              circle: false,
              strokeWidth: "0.5px",
            })}
          </Avatar>
        )}
      </ListItemAvatar>

      <ListItemText
        primary={<Typography sx={{ fontSize: "0.875rem" }}>{title}</Typography>}
        secondary={
          <Typography
            sx={{
              fontSize: "0.75rem",
              color: "var(--black-40, rgba(0, 0, 0, 0.40))",
            }}
          >
            {subtitle}
          </Typography>
        }
      />
    </ListItem>
  );
};
export default ListTile;
